import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ScreenLockPortraitIcon(props: IconProps) {
    return <Icon {...props} iconKey={"screen_lock_portrait"}/>
}
